import React from 'react';
import { Leaf, X } from 'lucide-react';
import GoogleSignInButton from './GoogleSignInButton';

// Login modal, opened from the header or any lock overlay. `reason` lets the
// caller say which feature the visitor was trying to unlock.
const LoginModal = ({ open, onClose, onLogin, reason }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
              <Leaf size={22} />
            </div>
            <div>
              <h1 className="text-lg font-bold text-gray-900">TheLeaf</h1>
              <p className="text-xs text-gray-500">Sign in to unlock the full toolkit</p>
            </div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" aria-label="Close">
            <X size={20} />
          </button>
        </div>

        {reason && (
          <div className="mt-4 rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-800">
            {reason}
          </div>
        )}

        <ul className="mt-4 space-y-1.5 text-sm text-gray-600">
          <li>✓ Entry / take-profit / stop signals with scores</li>
          <li>✓ Regime Intelligence &amp; market-quality model</li>
          <li>✓ Matching projection &amp; seasonal edges</li>
          <li>✓ Pair-trading cointegration &amp; backtests</li>
        </ul>

        <div className="mt-5 flex justify-center">
          <GoogleSignInButton onLogin={onLogin} />
        </div>

        <p className="mt-4 text-center text-[11px] text-gray-400">
          Free to view charts. Sign in with Google — no password.
        </p>
      </div>
    </div>
  );
};

export default LoginModal;
